import theme from '@styles/theme';
import reusables from '@styles/theme/reusables';
export default {
  breadcrumbsContainer: {
    width: '100%',
    zIndex: theme.zIndex.breadcrumbs,
    display: 'flex',
    flexFlow: 'row nowrap',
    whiteSpace: 'nowrap',
    position: 'relative'
  },
  breadcrumbContainer: {
    position: 'relative',
    overflowX: 'auto',
    p: ['12px 16px', '12px 16px', '12px 24px', '12px 40px'],
    scrollbarWidth: 'none',
    msOverflowStyle: 'none',
    '&::-webkit-scrollbar': {
      display: 'none'
    }
  },
  breadcrumb: {
    display: 'inline-flex',
    fontSize: 'caption',
    fontFamily: 'uniform',
    position: 'relative'
  },
  divider: {
    m: '0 calc(1rem * 0.75)',
    color: theme.rawColors.darkGrey300
  },
  breadcrumbLink: (activeDropdown: boolean, isLast: boolean) => ({
    cursor: 'pointer',
    color: `${isLast ? theme.rawColors.darkGrey700 : activeDropdown ? theme.rawColors.darkGrey700 : theme.rawColors.darkGrey300} !important`,
    position: 'relative',
    display: ['none', 'none', 'none', 'block']
  }),
  breadcrumbLinkMobile: (activeDropdown: boolean, isLast: boolean) => ({
    color: `${isLast ? theme.rawColors.darkGrey700 : activeDropdown ? theme.rawColors.darkGrey700 : theme.rawColors.darkGrey300} !important`,
    display: ['block', 'block', 'block', 'none'],
    outline: 'none',
    border: 'none',
    background: theme.rawColors.neutralWhite,
    WebkitTapHighlightColor: 'transparent',
    WebkitTouchCallout: 'none',
    WebkitUserSelect: 'none',
    userSelect: 'none'
  }),
  breadcrumbInactive: (activeDropdown: boolean, isLast: boolean) => ({
    color: `${isLast ? theme.rawColors.darkGrey700 : activeDropdown ? theme.rawColors.darkGrey700 : theme.rawColors.darkGrey300} !important`
  }),
  breadcrumbDropdown: (isVisible: boolean) => ({
    position: 'absolute',
    top: 'calc(100% - 14px)',
    left: '20px',
    backgroundColor: theme.rawColors.neutralWhite,
    border: `1px solid ${theme.rawColors.lightGrey300}`,
    display: 'inline-flex',
    flexDirection: 'column',
    justifyContent: 'start',
    alignItems: 'center',
    minWidth: '150px',
    maxHeight: '504px',
    overflowY: 'auto',
    opacity: 0,
    transform: 'translateY(-10px)',
    transition: 'opacity 0.3s ease, transform 0.2s ease, left 0.1s ease',
    visibility: 'hidden',
    ...reusables.scrollbar(),
    ...(isVisible && {
      opacity: 1,
      transform: 'translateY(0)',
      visibility: 'visible'
    })
  }),
  dropdownItem: {
    padding: '8px',
    width: '100%',
    textAlign: 'left',
    display: 'inline-flex',
    alignItems: 'center',
    gap: '10px',
    color: `${theme.rawColors.darkGrey600} !important`,
    fontSize: 'caption',
    '&:hover': {
      backgroundColor: theme.rawColors.lightGrey300,
      a: {
        color: `${theme.rawColors.darkGrey700} !important`
      }
    }
  },
  dropdownItemLink: {
    transition: 'none !important',
    color: `${theme.rawColors.darkGrey600} !important`
  },
  dropdownItemActive: {
    padding: '8px',
    width: '100%',
    textAlign: 'left',
    display: 'inline-flex',
    alignItems: 'center',
    gap: '10px',
    backgroundColor: theme.rawColors.lightGrey300,
    color: `${theme.rawColors.darkGrey700} !important`,
    cursor: 'default',
    fontSize: 'caption'
  },
  breadcrumbContent: {
    display: 'flex',
    alignItems: 'center',
    gap: '4px'
  },
  chevronContainer: {
    display: ['block', 'block', 'block', 'none', 'none'],
    height: '16px',
    width: '16px',
    outline: 'none',
    border: 'none',
    background: theme.rawColors.neutralWhite,
    WebkitTapHighlightColor: 'transparent',
    WebkitTouchCallout: 'none',
    WebkitUserSelect: 'none',
    userSelect: 'none'
  },
  chevronIcon: {
    rotate: '-90deg'
  }
};